module.exports = __webpack_public_path__ + "static/zendesk-a350aa52bcfacf20a03ca409accb8edf.svg";